const hardDeleteEquipmentServices = {
  toastr: 'Inspeção deletada'
};

export default hardDeleteEquipmentServices;
